// extracted by mini-css-extract-plugin
export default {"container":"bV-z"};